// hook to track user's search data
import { useCallback } from "react";
import { useAuth } from "@context/shared/AuthContext";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";

const SESSION_KEY = "client_session_id";

function getOrCreateSessionId() {
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (stored) return parseInt(stored, 10);

  const arr = new Int32Array(1);
  crypto.getRandomValues(arr);
  const id = Math.abs(arr[0]) || 1;
  sessionStorage.setItem(SESSION_KEY, String(id));
  return id;
}

export function useSearchTracking() {
  const { user, isAuthenticated } = useAuth();

  const trackSearch = useCallback(
    (query, results, duration) => {
      if (!isAuthenticated || !user?.id) return;

      apiClient
        .post(`${API.BASE}${API.FRONTEND.SEARCH_AUDITS}`, {
          userID: user.id,
          sessionID: getOrCreateSessionId(),
          query,
          results,
          duration,
        })
        .catch(() => {});
    },
    [user, isAuthenticated],
  );

  return { trackSearch };
}
